import React, { useState, useEffect } from "react";
import axiosInstance from "../../axiosInstance"; // Adjust the import as needed
import GeneralTable from "../../components/Table/GeneralTable";
import StatusCard from "../../components/StatusCard/StatusCard"; // Import StatusCard
import "./TeamLogs.scss";

const TeamLogs = () => {
  const columns = [
    { header: "Employee", accessor: "employeeName" },
    { header: "Role", accessor: "roleName" },
    { header: "Date", accessor: "attendanceDate" },
    { header: "Punch In Time", accessor: "punchInTime" },
    { header: "Punch In Status", accessor: "punchInStatusBadge" },
    { header: "Punch Out Time", accessor: "punchOutTime" },
    { header: "Punch Out Status", accessor: "punchOutStatusBadge" },
    { header: "Attendance Type", accessor: "attendanceType" },
  ];

  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [roleFilter, setRoleFilter] = useState("");
  const [attendanceTypeFilter, setAttendanceTypeFilter] = useState("");

  useEffect(() => {
    const fetchAttendanceData = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_MANAGER_URL}/attendance/All`
        );

        console.log("Attendance API Response:", response); // Debugging log

        if (response.status !== 200) {
          throw new Error("Failed to fetch attendance data");
        }

        const fetchedData = response.data.data.map((record) => ({
          employeeName: record.employeeName,
          roleName: record.roleName,
          attendanceDate: record.attendanceDate,
          punchInTime: record.punchInTime || "--",
          punchInStatus: record.punchInStatus || "N/A",
          punchInStatusBadge: (
            <StatusCard status={record.punchInStatus || "N/A"} />
          ),
          punchOutTime: record.punchOutTime || "--",
          punchOutStatus: record.punchOutStatus || "N/A",
          punchOutStatusBadge: (
            <StatusCard status={record.punchOutStatus || "N/A"} />
          ),
          attendanceType: record.attendanceType || "N/A",
        }));

        // console.log("Fetched Attendance Data:", fetchedData);

        setAttendanceData(fetchedData);
        setFilteredData(fetchedData);
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      }
    };

    fetchAttendanceData();
  }, []);

  const handleRoleFilterChange = (e) => {
    setRoleFilter(e.target.value);
    applyFilters(e.target.value, attendanceTypeFilter);
  };

  const handleAttendanceTypeFilterChange = (e) => {
    setAttendanceTypeFilter(e.target.value);
    applyFilters(roleFilter, e.target.value);
  };

  const applyFilters = (role, attendanceType) => {
    const filtered = attendanceData.filter((item) => {
      const matchesRole = role ? item.roleName === role : true;
      const matchesAttendanceType = attendanceType
        ? item.attendanceType === attendanceType
        : true;
      return matchesRole && matchesAttendanceType;
    });
    setFilteredData(filtered);
  };

  const uniqueRoles = [...new Set(attendanceData.map((item) => item.roleName))];
  const uniqueAttendanceTypes = [
    ...new Set(attendanceData.map((item) => item.attendanceType)),
  ];

  return (
    <div className="team-logs-container">
      <h1 className="display6">Team Dashboard</h1>

      <div className="team-logs-filters">
        <label>
          Role:
          <select value={roleFilter} onChange={handleRoleFilterChange}>
            <option value="">All Roles</option>
            {uniqueRoles.map((role) => (
              <option key={role} value={role}>
                {role}
              </option>
            ))}
          </select>
        </label>

        <label>
          Attendance Type:
          <select
            value={attendanceTypeFilter}
            onChange={handleAttendanceTypeFilterChange}
          >
            <option value="">All Types</option>
            {uniqueAttendanceTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="team-logs-table-container">
        {error ? (
          <p className="error-message">{error}</p>
        ) : (
          <GeneralTable
            columns={columns}
            data={filteredData}
            className="teamlogs-table"
            title="Team Attendance"
          />
        )}
      </div>
    </div>
  );
};

export default TeamLogs;
